
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="currentColor">
  <g clip-path="url(#clip0_3144_18353)">
    <path d="M9.68691 10.5798H3.20025C2.86025 10.5798 2.58691 10.8465 2.58691 11.1732C2.58691 11.4998 2.86691 11.7665 3.20691 11.7665H9.68025C10.0202 11.7665 10.3002 11.4998 10.3002 11.1732C10.2802 10.8465 10.0136 10.5798 9.68691 10.5798Z"/>
    <path d="M12.5068 0.859919C12.2201 0.919919 12.0201 1.16659 12.0201 1.45992V11.1733C12.0201 11.8933 11.4135 12.4799 10.6601 12.4799H2.4468C2.19346 12.4866 1.99346 12.2866 1.98679 12.0333V10.3666C1.98679 10.1266 2.19346 9.92659 2.44013 9.92659H8.30013C9.67346 9.92659 10.7868 8.85325 10.7868 7.52659V2.13992C10.7868 1.14659 9.9468 0.333252 8.91346 0.333252H2.62013C1.58679 0.333252 0.753461 1.13992 0.753461 2.13992V12.0333C0.746795 12.9333 1.50679 13.6666 2.4468 13.6666H10.6601C12.0868 13.6666 13.2468 12.5466 13.2468 11.1666V1.43992C13.2535 1.06659 12.9068 0.779919 12.5068 0.859919Z"/>
  </g>
  <defs>
    <clipPath id="clip0_3144_18353">
      <rect width="13.3333" height="13.3333" transform="translate(0.333496 0.333252)"/>
    </clipPath>
  </defs>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'PaperManual',
    }) as DefineComponent
    </script>
    